export const blobToBase64 = (
  blob: Blob,
  callback: (str: string) => void
): void => {
  const reader = new FileReader();
  reader.onload = () => {
    const base64String = reader.result as string;
    callback(base64String);
  };
  reader.readAsDataURL(blob);
};
